'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

/**
 * Root error boundary — catches errors thrown from the root layout itself,
 * where app/error.tsx can no longer render. Replaces the root layout, so it
 * must render its own <html>/<body> and cannot rely on app CSS being loaded.
 */
export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'system-ui, sans-serif',
            textAlign: 'center',
            padding: '1rem',
          }}
        >
          <div>
            <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>Application Error</h1>
            <p style={{ color: '#666', marginBottom: '1rem' }}>
              An unexpected error occurred. Please try again or contact support if the problem
              persists.
            </p>
            <button
              type="button"
              onClick={reset}
              style={{
                padding: '0.5rem 1.25rem',
                borderRadius: '0.375rem',
                border: '1px solid #ccc',
                background: '#111',
                color: '#fff',
                cursor: 'pointer',
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
